import React from 'react';
import { useColorMode } from '@chakra-ui/react';

const Loader = () => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   return (
      <div className="flex flex-col items-center justify-center gap-4 p-8 h-64">
         {/* Custom Loader */}
         <div className="relative inline-block w-12 h-12">
            {/* Outer rotating border (white) */}
            <div
               className={`w-12 h-12 border-2 ${isDark ? 'border-white' : 'border-gray-800'} box-border`}
               style={{
                  animation: 'rotation 2s linear infinite',
               }}></div>

            {/* Middle rotating border (orange/red) - rotates backward */}
            <div
               className="absolute left-0 right-0 top-0 bottom-0 m-auto w-[38px] h-[38px] border-2 border-orange-600 box-border"
               style={{
                  animation: 'rotationBack 1.5s linear infinite',
                  transformOrigin: 'center center',
               }}></div>

            {/* Inner rotating border (white) */}
            <div
               className={`absolute left-0 right-0 top-0 bottom-0 m-auto w-7 h-7 border-2 ${
                  isDark ? 'border-white' : 'border-gray-800'
               } box-border`}
               style={{
                  animation: 'rotation 1s linear infinite',
                  transformOrigin: 'center center',
               }}></div>
         </div>

         {/* Custom Animation Keyframes */}
         <style jsx>{`
            @keyframes rotation {
               0% {
                  transform: rotate(0deg);
               }
               100% {
                  transform: rotate(360deg);
               }
            }

            @keyframes rotationBack {
               0% {
                  transform: rotate(0deg);
               }
               100% {
                  transform: rotate(-360deg);
               }
            }
         `}</style>
      </div>
   );
};

export default Loader;
